import styled from 'styled-components';
export const Icon = styled.svg`
  width: ${props => props.width || '25px'};
  height: ${props => props.height || '25px'};
`;
export const STATE_NORMAL = 'normal';
export const STATE_ACTIVE = 'active';
export const STATES = [STATE_NORMAL, STATE_ACTIVE];
export const StatefulIcon = styled(Icon)`
  color: ${props => {
  var _props$color;

  return (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : 'currentColor';
}};

  .${STATE_NORMAL} {
    display: ${props => props.state === STATE_NORMAL ? 'block' : 'none'};
  }

  .${STATE_ACTIVE} {
    display: ${props => props.state === STATE_ACTIVE ? 'block' : 'none'};
  }
`;